import { Injectable, OnInit } from "@angular/core";
import { Platform } from "@ionic/angular";
import { ConfigService } from "../config/config.service";
import { GameHubControllerService } from "../gameHub/game-hub-controller";
import { ScrollService } from "../scroll/scroll.service";
import { WebservicesService } from "../webservices/webservices.service";
import { UserSessionService } from "../user-session/user-session.service";
import { Navigator } from "src/app/components/menu/navigator";
import { LevelService } from "../lobby/level.service";
import { LobbyService } from "../lobby/lobby.service";
import { GamesService } from "../lobby/games.service";
import { BehaviorSubject } from "rxjs";
import { LoginService } from "../login/login.service";


@Injectable({
    providedIn: 'root'
})
export class GalleryService implements OnInit {
    private lobbyName: string;
    public isMobileApp: boolean = false;
    public pageSizeSet = 25;
    customerId: number;
    favoriteGames: any[] = [];
    public pageSize: number = this.pageSizeSet;

    public gameListSubject = new BehaviorSubject<any[]>([]);
    public gameList$ = this.gameListSubject.asObservable();
    public gameList: any[] = [];
    public sortedGames: any[] = [];
    public loadedGames: BehaviorSubject<any> = new BehaviorSubject<any>([]);

    constructor(
        private readonly config: ConfigService,
        private readonly gameHubControllerService: GameHubControllerService,
        private readonly lobbyService: LobbyService,
        private readonly levelService: LevelService,
        private readonly loginService: LoginService,
        private readonly gamesService: GamesService,
        private readonly navigator: Navigator,
        private readonly platform: Platform,
        private readonly scroll: ScrollService,
        private readonly webservices: WebservicesService,
        private readonly userSessionService: UserSessionService,
    ) {
        this.isMobileApp = this.platform.is('capacitor');
        this.userSessionService.getCustomer().subscribe(
            (customer) => {
                if (customer?.customerId) {
                    this.customerId = customer.customerId;
                }
            }
        );
    }

    protected currentLevel: number;
    ngOnInit(): void {
        this.getLevel();
    }

    private getLevel(): void {
        this.levelService.level$.subscribe((res) => {
            if (res) this.currentLevel = res;
        });
    }

    public async getGameList(): Promise<any[]> {
        this.customerId = +this.loginService.getCustomerIDFromLocalStorage()
        if (!this.customerId) {
            await this.userSessionService.refreshCustomer().subscribe((response: any) => {
                if (response?.customerId) {
                    this.customerId = response.customerId;
                }
            }
            );
        }
        if (this.gameList.length > 0 && !this.customerId) {
            return this.gameList;
        } else if (this.sortedGames?.length > 0 && this.customerId) {
            return this.sortedGames;
        }

        try {
            const lobbyResponse = await this.fetchLobby();
            if (!!lobbyResponse.result && lobbyResponse.payload && lobbyResponse.payload[0]?.name) {
                this.lobbyName = lobbyResponse.payload[0].name;

                const gamesResponse = await this.fetchGames();
                if (gamesResponse?.result == 1) {
                    this.gameList = gamesResponse?.payload['All Games'];
                    this.loadedGames.next(this.gameList);
                }
                (await this.getFavoriteGames())?.subscribe(async (result) => {
                    if (!result) return;
                    this.favoriteGames = result.payload;
                    console.log(this.favoriteGames)
                    await this.setFavoriteGames();
                    this.sortedGames = this.gameList.sort((game) => {
                        for (let i = 0; i < this.favoriteGames.length; i++) {
                            if (game.id === this.favoriteGames[i].id) return -1;
                        }
                        return 1;
                    });
                    this.gameList = this.sortedGames;
                });
            }
        } catch (error) {
            console.log("Error Fetching Games", error);
            this.loadedGames.next([]);
        }
        return this.gameList;
    }

    public async getFavoriteGames() {
        await this.userSessionService.getCustomer().subscribe(
            (customer) => {
                if (customer?.customerId) {
                    this.customerId = customer.customerId;
                }
            }
        );
        if (!this.customerId) return;
        const obj = {
            customer_id: this.customerId,
            session_token: this.userSessionService.getSessionToken(),
        }
        return this.webservices.get("lobby/get-favourite-games", obj);
    }

    async setFavoriteGames() {
        this.gamesService.primaryGames = this.gameList
        this.gamesService.createFavouriteStore(this.favoriteGames);
        this.gamesService.favouriteGames = this.favoriteGames;
        if (!this.gamesService.primaryGames["Favorites"]) this.gamesService.combineAndEmit(this.gamesService.primaryGames);
    }

    public async fetchLobby(): Promise<any> {
        const obj = {
            clientapp: this.config.getClientApp(),
        }
        return this.webservices.get('lobby/get-lobbies-keywords', obj).toPromise();
    }

    public async fetchGames(): Promise<any> {
        const obj = {
            clientapp: this.config?.getClientApp(),
        }

        return this.webservices.get(`lobby/${this.lobbyName}/games`, obj).toPromise();
    }

    public getGamesImagePath(): string {
        return `${this.config?.getConfig()?.CDN_BASEURL}/assets/social/games/`;
    }

    public doInfinite(e) {
        setTimeout(() => {
            this.increasePageSize();
            e.target.complete();
        }, 50000);
    }

    public increasePageSize() {
        this.pageSize += this.pageSizeSet;
    }

    public getPageSize(): number {
        return this.pageSize;
    }

    public onContainerScroll(e) {
        if (this.isMobileApp) this.scroll.setScrollPosition(e);
    }

    public launchCasinoGame(gameData): any {
        this.userSessionService.isAuthenticated().then((auth) => {
            if (auth) {
                return this.gameHubControllerService.launchCasinoGame(gameData);
            } else {
                return this.navigator.navigateTo('LoginComponent', { customModalClass: 'crown-modal', animated: false });
            }
        })
    }

    public openGameDetailPage(gameData): any {

        this.gameListSubject.next(gameData);

        this.userSessionService.isAuthenticated().then((auth) => {
            if (auth) {
                return setTimeout(() => {
                    this.navigator.navigateTo('GameDetailPageComponent', { customModalClass: 'game-detail-screen', multipleModals: false });
                }, 550); // This time corresponds to fliponclick directive tile animation
            }

            return setTimeout(() => {
                this.lobbyService.setWaitingGameData(gameData);
                this.navigator.navigateTo('LoginComponent', { customModalClass: 'crown-modal', animated: false });
            }, 550);
        });
    }
}
